export const useContentfulFetch = async (options: {
  url: string,
  query?: Record<string, any>
}) => {
  const { url, query } = options
  const { locale } = useI18n()
  const router = useRouter()

  const defaultQuery = {
    locale: locale.value,
    path: router.currentRoute.value.path,
    contentModelOptions: {
      adapter: 'pageData',
      enabledPreview: false,
      route: '/',
      multiplyLanguages: true,
    },
  }

  const deepMerge = (target: any, source: any): any => {
    const result = { ...target }
    for (const key in source) {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        result[key] = deepMerge(result[key], source[key])
      } else {
        result[key] = source[key]
      }
    }
    return result
  }

  const mergedQuery = deepMerge(defaultQuery, query || {})

  try {
    const res = await $fetch(url, { query: mergedQuery })
    return (res as any)?.content || null
  }
  catch (e) {
    console.error(e)
    return null
  }
}
